module.exports = __webpack_public_path__ + "img/CreditCardOutlined.d3604d98.svg";